import { Component, ViewChild, OnInit } from '@angular/core';
import { pool, build, ReactiveDropdownSyncController } from '@fitogest/reactive-form-builder/utils';
import { ActivatedRoute, Router } from '@angular/router';
import { FormCommonApiService } from '../../../../../service/api/formcommon-api.service';
import { FincasApiService } from '../../../../../service/api/fincas-api.service';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { BaseForm } from '../../../../../view/base-form';
import { CamposApiService } from '../../../../../service/api/campos-api.service';
import { VisitasVariedadMesApiService } from '../../../../../service/api/visitas_variedad_mes-api.service';
import { MapaParcelasApiService } from '../../../../../service/api/mapa-parcelas-api.service';

import { FullMapModel } from 'src/app/models/form-common/full-map.model';
import { VisitasVariedadMesModel } from 'src/app/models/visitas_variedad_mes/visitas_variedad_mes.model';
import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';
import { CamposFormDefinition } from './form-definition';
import { ReactiveFormBuilderComponent } from '@fitogest/reactive-form-builder';
import { EventPhase, FormPhase, ReactiveFormRequestCoordinator } from '@fitogest/reactive-form-builder/form-request';
import { CamposEnvironmentDefinition } from '../environment-variables';
import { StorageManager } from 'src/app/common/storage-manager.class';
import { Utils } from 'src/app/common/utils';
import { ReactiveFormChangedField, ReactiveFormStableValueChange, ReactiveFormValue } from '@fitogest/reactive-form-builder/interfaces';
@Component({
    selector: 'app-campos-form',
    standalone: false,
    templateUrl: './campos-form.component.html',
    styleUrls: ['./campos-form.component.scss']
})
export class CamposFormComponent extends BaseForm<ParcelasModel> implements OnInit {

    @ViewChild(ReactiveFormBuilderComponent) cultivosFormBuilder!: ReactiveFormBuilderComponent<VisitasVariedadMesModel>;

    public form!: CamposFormDefinition;

    public env: CamposEnvironmentDefinition = new CamposEnvironmentDefinition();

    public formRequest = new ReactiveFormRequestCoordinator<ParcelasModel>;

    public mapaAux = {} as FullMapModel;

    public override model = {} as ParcelasModel;

    public reactiveFormRecordId = '';
    public modelCultivo = {} as VisitasVariedadMesModel;

    constructor(
        public override route: ActivatedRoute,
        public override router: Router,
        public formApi: FormCommonApiService,
        public fincasApi: FincasApiService,
        public camposApi: CamposApiService,
        public mapaParcelasApi: MapaParcelasApiService,
        public override dashboard: DashboardService,
        public visitasVariedadMesApi: VisitasVariedadMesApiService,
    ) {
        super(
            route,
            router,
            dashboard,
            camposApi.campos.PUT,
            camposApi.campos.POST,
            'campos',
            'Editar Campo',
            'Crear Campo'
        );
    }

    ngOnInit() {
        this.resetExternalDropdowns();
        const routeModel = this.getModel() as unknown as ParcelasModel;

        this.reactiveFormRecordId = this.resolveReactiveFormRecordId(routeModel);
        this.initializeHostModel(routeModel);
        this.form = new CamposFormDefinition(
            this.getType(),
            routeModel as unknown as Record<string, string>,
            null,
            {
                cultivos: this.formApi.cultivosGET,
                variedades: this.formApi.variedadesGET
            }
        );
        this.formRequest.executePhase(FormPhase.LOAD);
        this.formRequest.addEvent(FormPhase.LOAD, EventPhase.AFTER, (resolve) => {
            if (localStorage.getItem('TEMP_CAMPO_DATA')) {
                this.form.model = JSON.parse(localStorage.getItem('TEMP_CAMPO_DATA') ?? '');
                localStorage.removeItem('TEMP_CAMPO_DATA');
            }
            if (this.form.model.marco) {
                const parts = this.form.model.marco.split('x');
                this.form.model.marco_ancho = parts[0] ?? '';
                this.form.model.marco_largo = parts[1] ?? '';
                this.formBuilderRef.updateForm(this.form.model, true);
            }
            resolve(true);
        });

        this.formRequest.addEvent(FormPhase.SEND, EventPhase.BEFORE, (resolve) => {
            if (this.model.mapa && this.model.mapa[0]) {
                this.mapaAux = this.model.mapa[0];
            }
            resolve(true);
        });

        this.initFormData();

        this.softInit(this.getType());
    }

    public async afterSendCultivo(_res: any): Promise<void> {
        localStorage.setItem('TEMP_CAMPO_DATA', JSON.stringify(this.model));
        window.location.reload();
    }

    public async afterSend(res: any): Promise<void> {
        const parcela = res?.[0];

        if (parcela && this.mapaAux.coordenadas) {
            // Rellena campos que vienen del backend de parcelas
            this.mapaAux.id_parcela = parcela.id;
            this.mapaAux.id_finca = parcela.id_finca;
            if (this.env.hasClients) {
                this.mapaAux.id_cliente = parcela.id_cliente ?? '';
            }
            this.mapaAux.id_cultivo = parcela.id_cultivo ?? '';
            this.mapaAux.id_sector = parcela.id_sector ?? '';

            try {

                // 1) Comprueba si ya existe un registro de mapa para esta parcela
                const existentes = await this.mapaParcelasApi.mapaParcelasGET.toPromise() as FullMapModel[] || [];
                const existente = existentes.find(m => m.id_parcela === this.mapaAux.id_parcela); // igualdad laxa por tipos

                // 2) PUT si existe, POST si no
                if (existente?.id) {
                    this.mapaAux.id = existente.id;
                    await this.mapaParcelasApi.mapaParcelasPUT.toPromise(this.mapaAux);
                } else {
                    await this.mapaParcelasApi.mapaParcelasPOST.toPromise(this.mapaAux);
                }
            } catch (e) {
                console.error('Error sincronizando mapa_parcelas', e);
                // (opcional) aquí puedes mostrar un toast/notificación
            }
        }

        this.goBack();
    }

    public stableValueChanges(event: ReactiveFormStableValueChange<ParcelasModel>): void {
        this.handleReactiveValueChange(event.value, event.changedField);
    }

    public stableValueChangesCultivos(event: ReactiveFormStableValueChange<ParcelasModel>): void {
        this.handleReactiveValueChange(event.value, event.changedField);
    }

    private handleReactiveValueChange(
        formModel: ReactiveFormValue<ParcelasModel>,
        lastChangedFieldName: ReactiveFormChangedField<ParcelasModel>
    ): void {
        this.form.model = formModel;
        this.form.tag = lastChangedFieldName;
        this.syncModelFromForm();
    }

    public getFromMapa(datos: string){
        const data = JSON.parse(datos);

        const ratio = StorageManager.getUser().ratio_ha;
        if (ratio != null && ratio !== 1) {
            data.ha = data.ha * (ratio || 1);
            data.ha = Utils.decimalFormat(data.ha, 2);
        }


        this.form.model.cod_provincia = data.provincia;
        this.form.model.municipio = data.municipio;
        this.form.model.poligono = data.poligono;
        this.form.model.numero = data.parcela;
        this.form.model.recinto = data.recinto;
        this.form.model.superficie_sigpac = data.ha;
        this.form.model.id_cultivo = data.cultivo;
        this.form.model.id_variedad = data.variedad;
        this.form.model.sigpac = data.refpar;

        if (!this.form.model.mapa) {
            this.form.model.mapa = [{} as FullMapModel];
        }
        if (this.form.model.mapa[0]) {
            this.form.model.mapa[0].id_finca = this.model.id_finca ?? '';
            this.form.model.mapa[0].id_usuario = StorageManager.getUser().id;
            this.form.model.mapa[0].coordenadas = data.coord;
            this.form.model.mapa[0].color = data.color;

            if (this.form.parcelaNombre !== '' && this.form.parcelaNombre != null) {
                this.model.nombre = this.form.parcelaNombre;
            }
            else {
                this.model.nombre = `${this.env.parcelaName} ${data.parcela}`;
            }

        }

        this.form.mapaAbierto = false;
    }


    private syncModelFromForm(): void {
        const normalizedModel = { ...(this.form.model as Record<string, unknown>) } as unknown as ParcelasModel;

        this.form.model = normalizedModel;
        this.updateHostModel(normalizedModel);
    }

    private initFormData(): Promise<boolean> {
        return pool([
            build(this.fincasApi.fincasGET, this.form.lists.fincas, ['nombre']),
            build(this.fincasApi.parcelasGET, this.form.lists.parcelas, ['nombre'])
        ]).then(() => {
            this.finalizeExternalDropdowns();
            this.refreshReactiveDropdownMappings();
            return true;
        });
    }

    private refreshReactiveDropdownMappings(): void {
        ReactiveDropdownSyncController.refreshMappings({ formBuilder: this.formBuilderRef });
        ReactiveDropdownSyncController.refreshMappings({ formBuilder: this.cultivosFormBuilder });
    }
}